/* tslint:disable */
/* eslint-disable */
/**
 * Rejeem API
 * Rejeem API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { CreatePlanOptionRequest } from '../model';
// @ts-ignore
import { PlanOptionDetailResponse } from '../model';
// @ts-ignore
import { UpdatePlanOptionRequest } from '../model';
/**
 * AdminPlanOptionControllerApi - axios parameter creator
 * @export
 */
export const AdminPlanOptionControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} planId 
         * @param {CreatePlanOptionRequest} createPlanOptionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPlanOption: async (planId: string, createPlanOptionRequest: CreatePlanOptionRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planId' is not null or undefined
            assertParamExists('createPlanOption', 'planId', planId)
            // verify required parameter 'createPlanOptionRequest' is not null or undefined
            assertParamExists('createPlanOption', 'createPlanOptionRequest', createPlanOptionRequest)
            const localVarPath = `/admin/plans/{planId}/options`
                .replace(`{${"planId"}}`, encodeURIComponent(String(planId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPlanOptionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} planOptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePlanOption: async (planOptionId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planOptionId' is not null or undefined
            assertParamExists('deletePlanOption', 'planOptionId', planOptionId)
            const localVarPath = `/admin/plan-options/{planOptionId}`
                .replace(`{${"planOptionId"}}`, encodeURIComponent(String(planOptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} planOptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlanOptionById: async (planOptionId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planOptionId' is not null or undefined
            assertParamExists('getPlanOptionById', 'planOptionId', planOptionId)
            const localVarPath = `/admin/plan-options/{planOptionId}`
                .replace(`{${"planOptionId"}}`, encodeURIComponent(String(planOptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} planOptionId 
         * @param {UpdatePlanOptionRequest} updatePlanOptionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePlanOption: async (planOptionId: string, updatePlanOptionRequest: UpdatePlanOptionRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planOptionId' is not null or undefined
            assertParamExists('updatePlanOption', 'planOptionId', planOptionId)
            // verify required parameter 'updatePlanOptionRequest' is not null or undefined
            assertParamExists('updatePlanOption', 'updatePlanOptionRequest', updatePlanOptionRequest)
            const localVarPath = `/admin/plan-options/{planOptionId}`
                .replace(`{${"planOptionId"}}`, encodeURIComponent(String(planOptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePlanOptionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminPlanOptionControllerApi - functional programming interface
 * @export
 */
export const AdminPlanOptionControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminPlanOptionControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} planId 
         * @param {CreatePlanOptionRequest} createPlanOptionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPlanOption(planId: string, createPlanOptionRequest: CreatePlanOptionRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPlanOption(planId, createPlanOptionRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} planOptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePlanOption(planOptionId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePlanOption(planOptionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} planOptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPlanOptionById(planOptionId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlanOptionDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPlanOptionById(planOptionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} planOptionId 
         * @param {UpdatePlanOptionRequest} updatePlanOptionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePlanOption(planOptionId: string, updatePlanOptionRequest: UpdatePlanOptionRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePlanOption(planOptionId, updatePlanOptionRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AdminPlanOptionControllerApi - factory interface
 * @export
 */
export const AdminPlanOptionControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminPlanOptionControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} planId 
         * @param {CreatePlanOptionRequest} createPlanOptionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPlanOption(planId: string, createPlanOptionRequest: CreatePlanOptionRequest, options?: any): AxiosPromise<void> {
            return localVarFp.createPlanOption(planId, createPlanOptionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} planOptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePlanOption(planOptionId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deletePlanOption(planOptionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} planOptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlanOptionById(planOptionId: string, options?: any): AxiosPromise<PlanOptionDetailResponse> {
            return localVarFp.getPlanOptionById(planOptionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} planOptionId 
         * @param {UpdatePlanOptionRequest} updatePlanOptionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePlanOption(planOptionId: string, updatePlanOptionRequest: UpdatePlanOptionRequest, options?: any): AxiosPromise<void> {
            return localVarFp.updatePlanOption(planOptionId, updatePlanOptionRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminPlanOptionControllerApi - object-oriented interface
 * @export
 * @class AdminPlanOptionControllerApi
 * @extends {BaseAPI}
 */
export class AdminPlanOptionControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} planId 
     * @param {CreatePlanOptionRequest} createPlanOptionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminPlanOptionControllerApi
     */
    public createPlanOption(planId: string, createPlanOptionRequest: CreatePlanOptionRequest, options?: AxiosRequestConfig) {
        return AdminPlanOptionControllerApiFp(this.configuration).createPlanOption(planId, createPlanOptionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} planOptionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminPlanOptionControllerApi
     */
    public deletePlanOption(planOptionId: string, options?: AxiosRequestConfig) {
        return AdminPlanOptionControllerApiFp(this.configuration).deletePlanOption(planOptionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} planOptionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminPlanOptionControllerApi
     */
    public getPlanOptionById(planOptionId: string, options?: AxiosRequestConfig) {
        return AdminPlanOptionControllerApiFp(this.configuration).getPlanOptionById(planOptionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} planOptionId 
     * @param {UpdatePlanOptionRequest} updatePlanOptionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminPlanOptionControllerApi
     */
    public updatePlanOption(planOptionId: string, updatePlanOptionRequest: UpdatePlanOptionRequest, options?: AxiosRequestConfig) {
        return AdminPlanOptionControllerApiFp(this.configuration).updatePlanOption(planOptionId, updatePlanOptionRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

